import React, {FC, useContext} from 'react';
import {AsyncIdFilterInput} from "./AsyncIdFilterInput";
import {LanguageContext} from "../../../config/ContextConfig";
import {ProjectStageFilterInputProps} from "./ProjectStageFilterInput";
import {projectPhaseSelectRoute} from "../../../models/projects/ProjectStagePhase";

export interface ProjectStagePhaseFilterInputProps extends ProjectStageFilterInputProps {
    projectStageId: number
}

export const projectStagePhaseFilterName = 'phaseId';

/**
 * ProjectStagePhaseFilterInput is a wrapper component around AsyncIdFilterInput
 *
 * it providers a select input to choose the project you want in the dataset from the API backend
 *
 * @see AsyncIdFilterInput
 *
 *
 * @constructor
 */
export function ProjectStagePhaseFilterInput( props: ProjectStagePhaseFilterInputProps ) {
    const language = useContext( LanguageContext );

    return (
        <AsyncIdFilterInput
            {...props}
            title={language.projects.rowProjectStagePhase}
            route={ projectPhaseSelectRoute( props.projectId, props.projectStageId )}
            filterName={props.filterName ?? projectStagePhaseFilterName }
        />
    );
}